module.exports = __webpack_public_path__ + "img/mu-img-dasboard.1fc23335.png";